export const SET_SUB_CATEGORY_PAGE_DATA = 'SET_SUB_CATEGORY_PAGE_DATA';
export const SET_SUB_CATEGORY_TOTAL_RECORDS = 'SET_SUB_CATEGORY_TOTAL_RECORDS';
export const SET_SUB_CATEGORY_PAGE = 'SET_SUB_CATEGORY_PAGE';
export const EDIT_SUB_CATEGORY = 'EDIT_SUB_CATEGORY';
export const ADD_SUB_CATEGORY = 'ADD_SUB_CATEGORY';
export const DELETE_SUB_CATEGORY= 'DELETE_SUB_CATEGORY';
export const SUB_CATEGORY_LOADING = 'SUB_CATEGORY_LOADING';
export const SUB_CATEGORY_FAILURE = 'SUB_CATEGORY_FAILURE';
export const GET_SUB_CATEGORY= 'GET_SUB_CATEGORY';
export const SET_SUB_CATEGORY_REDIRECT_URL = 'SET_SUB_CATEGORY_REDIRECT_URL';


export const SUB_CATEGORY_PROGRESS_TYPE={
    GET_SUB_CATEGORY_LIST:"GET_SUB_CATEGORY_LIST",
    ADD_SUB_CATEGORY_PROGRESS:"ADD_SUB_CATEGORY_PROGRESS",
    EDIT_SUB_CATEGORY_PROGRESS:"EDIT_SUB_CATEGORY_PROGRESS",
    DELETE_SUB_CATEGORY_PROGRESS:"DELETE_SUB_CATEGORY_PROGRESS"
}

